import React from 'react';
import CloseButton from '../../CloseButton';
import Heading from '../../Heading';
import { st, classes } from '../MessageBoxFunctionalLayout.st.css';
import { dataHooks } from '../MessageBoxFunctionalLayout.constants';
import Box from '../../Box';
import {
  MessageBoxFunctionalLayoutProps,
  MessageBoxFunctionalLayoutTheme,
} from '../MessageBoxFunctionalLayout.types';

export const HeaderLayout = ({
  title,
  onCancel,
  closeButton = true,
  size = 'medium',
}: Pick<
  MessageBoxFunctionalLayoutProps,
  'onCancel' | 'title' | 'closeButton'
> & {
  size: MessageBoxFunctionalLayoutProps['buttonsHeight'];
  theme?: MessageBoxFunctionalLayoutTheme;
}) => {
  return (
    <>
      <div className={st(classes.header)} data-hook={dataHooks.header}>
        <Heading
          size={size}
          light={false}
          className={classes.heading}
          dataHook={dataHooks.headerTitle}
        >
          {title}
        </Heading>
      </div>
      {closeButton ? (
        <Box className={classes.controlButtons}>
          <CloseButton
            dataHook={dataHooks.headerCloseButton}
            size="large"
            skin="dark"
            onClick={onCancel}
          />
        </Box>
      ) : null}
    </>
  );
};
